import React from 'react';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';

// Components
// @ts-ignore
import ScrollToTopOnPathnameUpdate from 'components/ScrollToTopOnPathnameUpdate';
import ErrorBoundary from 'components/SentryErrorBoundary';

// Scenes
// @ts-ignore
import Root from 'scenes/Root';

interface IProps {
    history: any;
}

const App = (props: IProps) => {
    const { history } = props;
    return (
        <ErrorBoundary>
            <ConnectedRouter history={history}>
                <ScrollToTopOnPathnameUpdate>
                    <Route path="/" component={Root} />
                </ScrollToTopOnPathnameUpdate>
            </ConnectedRouter>
        </ErrorBoundary>
    );
};

export default App;
